export class ArraysHelper {
    /*
    * Takes mutliple arrays and combines them into a multi-dimensional array
    * where each index of the arrays are combined into a the same array
    * 
    * Example:
    * a = ['a1', 'a2', 'a3']
    * b = ['b1', 'b2']
    * result = [['a1', 'b1'], ['a2', 'b2'], ['a3', undefined]]
    */

    public static zip<T>(...arrays: T[][]): (T | undefined)[][] {
        const maxLength = Math.max(...arrays.map(array => array.length));
        return Array(maxLength).fill(undefined).map((_, i) => arrays.map(array => array[i]));
    }

    public static areListsEqual = (a: any[] | undefined, b: any[] | undefined) => {
        const aList = a ?? [];
        const bList = b ?? [];
        return aList.length === bList.length && aList.every((value, index) => value === bList[index]);
    }
}